var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHastag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 34 34",
    style: {
      enableBackground: "new 0 0 34 34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6F109E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_57081",
    transform: "translate(-45 -755)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_9",
    transform: "translate(55 765.031)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9831",
    className: "st0",
    d: "M4.8,7.6h4.7l0.7-4.7H5.5L4.8,7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9832",
    className: "st0",
    d: "M21.6-1.4C20.9-4,18.7-6,16.1-6.7c-5.7-0.9-11.5-0.9-17.2,0C-3.8-6-5.9-4-6.6-1.4 C-7.1,0.7-7.3,2.9-7.3,5c0,2.2,0.2,4.3,0.6,6.4C-6,14-4,16-1.4,16.7c0.5,0.2,0.8,0.8,0.6,1.3c0,0.1-0.1,0.2-0.2,0.3 c-0.5,0.5-0.9,1-1.5,1.5c-0.6,0.5-0.6,1.4-0.1,1.9c0.3,0.3,0.6,0.5,1,0.5h0.1c3.9-0.2,7.6-1.3,10.9-3.4c1.4-0.9,3-1.5,4.7-1.8 c0.8-0.1,1.5-0.2,1.9-0.3c2.7-0.6,4.8-2.6,5.5-5.3c0.4-2.1,0.6-4.3,0.6-6.4C22.2,2.9,22,0.7,21.6-1.4L21.6-1.4z M13.5,2.8h-1.1 l-0.7,4.7h0.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c0,0,0,0,0,0h-1.1l-0.3,2.1c-0.1,0.5-0.5,0.9-1.1,0.9 c-0.1,0-0.1,0-0.2,0c-0.6-0.1-1-0.6-0.9-1.2l0.3-1.8H4.5l-0.3,2.1c-0.1,0.5-0.5,0.9-1.1,0.9c-0.1,0-0.1,0-0.2,0 c-0.6-0.1-1-0.6-0.9-1.2l0.3-1.8H1.4c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1c0,0,0,0,0,0h1.3l0.7-4.7H2.4 c-0.6,0-1.1-0.5-1.1-1.1s0.5-1.1,1.1-1.1h1.2l0.3-2.1c0.1-0.6,0.6-1,1.2-0.9c0.6,0.1,1,0.6,0.9,1.2l0,0L5.8,0.6h4.7l0.3-2.1 c0.1-0.6,0.6-1,1.2-0.9c0.6,0.1,1,0.6,0.9,1.2l0,0l-0.3,1.8h0.8c0.6,0,1.1,0.5,1.1,1.1C14.6,2.3,14.2,2.8,13.5,2.8 C13.6,2.8,13.5,2.8,13.5,2.8L13.5,2.8z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHastag);
export default __webpack_public_path__ + "static/media/hastag.479b2b54d9a661215868e11c3a760b8f.svg";
export { ForwardRef as ReactComponent };